import { ProjectEntity, VisitTypeEntity, VisitTypeTemplateName } from "@archipad-js/archipad-model";

export interface SystemVisitTypes {
    default: VisitTypeEntity | undefined;
    [VisitTypeTemplateName.AfterSalesService]: VisitTypeEntity | undefined;
    [VisitTypeTemplateName.Delivery]: VisitTypeEntity | undefined;
    [VisitTypeTemplateName.HandoverToRealization]: VisitTypeEntity | undefined;
    [VisitTypeTemplateName.RealizationToHandover]: VisitTypeEntity | undefined;
    [VisitTypeTemplateName.WorkPackage]: VisitTypeEntity | undefined;
    [VisitTypeTemplateName.HiddenExecution]: VisitTypeEntity | undefined;
    [VisitTypeTemplateName.HiddenDelivery]: VisitTypeEntity | undefined;
}

export function findSystemVisitTypes(project: ProjectEntity): SystemVisitTypes {
    const defaultVisitType = project.visitTypes.find((visitType) => visitType.isDefault);
    const afterSalesServiceVisitType = project.visitTypes.find(
        (visitType) => visitType.templateName === VisitTypeTemplateName.AfterSalesService,
    );
    const deliveryVisitType = project.visitTypes.find(
        (visitType) => visitType.templateName === VisitTypeTemplateName.Delivery,
    );
    const handoverToRealizationVisitType = project.visitTypes.find(
        (visitType) => visitType.templateName === VisitTypeTemplateName.HandoverToRealization,
    );
    const realizationToHandoverVisitType = project.visitTypes.find(
        (visitType) => visitType.templateName === VisitTypeTemplateName.RealizationToHandover,
    );
    const workPackageVisitType = project.visitTypes.find(
        (visitType) => visitType.templateName === VisitTypeTemplateName.WorkPackage,
    );
    const hiddenExecutionVisitType = project.visitTypes.find(
        (visitType) => visitType.templateName === VisitTypeTemplateName.HiddenExecution,
    );
    const hiddenDeliveryVisitType = project.visitTypes.find(
        (visitType) => visitType.templateName === VisitTypeTemplateName.HiddenDelivery,
    );

    return {
        default: defaultVisitType,
        [VisitTypeTemplateName.AfterSalesService]: afterSalesServiceVisitType,
        [VisitTypeTemplateName.Delivery]: deliveryVisitType,
        [VisitTypeTemplateName.HandoverToRealization]: handoverToRealizationVisitType,
        [VisitTypeTemplateName.RealizationToHandover]: realizationToHandoverVisitType,
        [VisitTypeTemplateName.WorkPackage]: workPackageVisitType,
        [VisitTypeTemplateName.HiddenExecution]: hiddenExecutionVisitType,
        [VisitTypeTemplateName.HiddenDelivery]: hiddenDeliveryVisitType,
    };
}
